import React, { Component } from 'react';
import { connect } from 'react-redux';
import {LOG_LEVELS} from "../../utils/logger";
import Logger from "../../utils/logger";
import _ from 'lodash';
import ComponentUtil from '../../utils/componentUtil';
import VATCodeSimulatorFilter from './VATCodeSimulatorFilter';
import VATCodeSimulation from './VATCodeSimulation';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';

import VATCODE_SIMULATOR_CONTROLLER from "../../controllers/vatCodeSimulator";
import {FIELDS as GLOBAL_FILTER_PANEL_FIELDS} from '../filter/GlobalFilterPanel';
import AuthorizedResource from '../authorization/AuthorizedResource';
import authorize from '../../utils/auth';

const PAGE_INTERNAL_IDS = [
  GLOBAL_FILTER_PANEL_FIELDS.PARAM_COMPANY_ID
];
const DefaultCompanyId=-1;
const log = new Logger('VATCODE_SIMULATOR_PAGE', LOG_LEVELS.DEBUG);

export class Page extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
          loading: true,
        };
        this.onSearchClickHandler = this.onSearchClickHandler.bind(this);
    }

    onSearchClickHandler(selection) {
        if(_.isEmpty(selection)) {
            return;
        } 
        const apiParams = {
            vatCode: selection.vatCode,
            companyId: selection.companyId,
            date: selection.date,
            isGenericVatCode: selection.isGenericCode
        };
        PAGE_INTERNAL_IDS.forEach(key => delete selection[key]);
        ComponentUtil.updateUrlParams(this.props.location, this.props.history, selection);
        this.props.onFilterApply(apiParams);
    }

    UNSAFE_componentWillMount() {
        log.debug('componentWillMount(): ', this.props);        
        this.props.onPageLoad({companyId:DefaultCompanyId}); //passing the defaultId -1 to get data for all companies
    }

    componentDidMount() {
        log.debug('componentDidMount()');
        log.clearAllDictionaryErrors();
    }

    componentWillUnMount(){
      this.props.doUnload();
    }

    render() {
        log.debug('render(): ', this.props);
        log.debug('render(): location.search:', this.props.location.search);

        return (
            <s-container data-test="component-page">
                <div className="content-area">
                    <h1><LanguageStringResolver string='vatCodeSimulator_Title'/></h1>
                    <VATCodeSimulatorFilter onSearchClick={this.onSearchClickHandler}/>
                    <VATCodeSimulation
                        vatCodeSimulator={this.props.vatCodeSimulator}
                    />
                </div>
                <div className="clear"></div>
            </s-container>
        );
    }
}

function mapStateToProps(state) {
    return {
      vatCodeDetails : (state.vatCodeSimulator && state.vatCodeSimulator.vatCodeDetails) || [],
      companies: (state.companies && state.companies.data ) || []
    };
}

function mapDispatchersToProps(dispatch) {
    const dispatchProps = {};
    dispatchProps.onPageLoad = (params) => {
      dispatch(VATCODE_SIMULATOR_CONTROLLER.doUnload());
      dispatch(VATCODE_SIMULATOR_CONTROLLER.doLoad(params));
    };
    dispatchProps.onFilterApply = (params) => {
        dispatch(VATCODE_SIMULATOR_CONTROLLER.doVATCodeSimulation(params));
    };
    dispatchProps.doUnload = () => {
      dispatch(VATCODE_SIMULATOR_CONTROLLER.doUnload());
    };
    return dispatchProps; 
}

export default  authorize({
    name: 'VATCodeSimulator',
    resource: connect(mapStateToProps, mapDispatchersToProps)(Page)
  }, AuthorizedResource, {
    showNotAuthorized: true
  });
  
